import WorkItemDetail from '../../../../../../app/assets/javascripts/work_items/components/work_item_detail.vue?vue3';
import ImplementationWidget from './implementation_widget/implementation_widget.vue?vue3';
import WorkplanStickyHeaderQuestions from './implementation_widget/workplan_sticky_header_questions.vue?vue3';
import WorkItemDecisionLog from './decision_log/work_item_decision_log.vue?vue3';
import WorkItemAgentSessions from './agent_sessions/index.vue?vue3';
import WorkItemPlanCta from './work_item_plan_cta.vue?vue3';
import { WORKPLAN_PANEL, DECISION_LOG_PANEL } from '~/work_items/constants';
import { findDecisionLogWidget, isWorkplanEnabled } from '../utils.js?vue3';
import glFeatureFlagsMixin from '~/vue_shared/mixins/gl_feature_flags_mixin';
import { glListenersMixin } from '~/lib/utils/vue3compat/gl_listeners_mixin';
export default {
    name: 'WorkItemDetailEE',
    WORKPLAN_PANEL,
    DECISION_LOG_PANEL,
    components: {
        WorkItemDetail,
        ImplementationWidget,
        WorkItemAgentSessions,
        WorkItemDecisionLog,
        WorkItemPlanCta,
        WorkplanStickyHeaderQuestions
    },
    mixins: [
        glFeatureFlagsMixin(),
        glListenersMixin
    ],
    inheritAttrs: false,
    methods: {
        isWorkplanAvailable (workItem) {
            return isWorkplanEnabled(workItem);
        },
        showDecisionLog (workItem) {
            return Boolean(this.glFeatures?.decisionLog) && Boolean(findDecisionLogWidget(workItem));
        },
        // Nothing pushes the open questions count, so answering a question refetches it here,
        // where both the discussion and the Workplan widget are rendered.
        refetchWorkplan () {
            this.$refs.implementationWidget?.refetchWorkplan();
        },
        // Flows can only run in a project, so Plan isn't offered on group-level work items.
        showPlanCta ({ workItem, editMode, canUpdate, agentPlanWidget }) {
            return Boolean(workItem?.project) && !editMode && canUpdate && Boolean(agentPlanWidget) && !agentPlanWidget.aiPlanningEnabled;
        }
    }
};
